const headerBurger = document.querySelector('.header__burger')

if (headerBurger) {
  headerBurger.addEventListener('click', (evt) => {
    const open = headerBurger.querySelector('.header__burger-menu')
    const close = headerBurger.querySelector('.header__burger-close')
    const header = document.querySelector('.header')
    const headerNav = document.querySelector('.header__nav')
    if (evt.target === open) {
      headerNav.classList.add('header__nav_open')
      open.classList.add('header__burger-menu_disable')
      close.classList.add('header__burger-close_enable')
      header.classList.add('header_mobile')
    } else if (evt.target === close) {
      headerNav.classList.remove('header__nav_open')
      open.classList.remove('header__burger-menu_disable')
      close.classList.remove('header__burger-close_enable')
      header.classList.remove('header_mobile')
    }
  })
}
const showMenuLangBtn = document.querySelector('.mobile-menu__btn')
if (showMenuLangBtn) {
  showMenuLangBtn.addEventListener('click', () => {
    const langMenu = document.querySelector('.mobile-menu__langs')
    if (langMenu.clientHeight === 0) {
      langMenu.style.height = langMenu.scrollHeight + 'px'
      showMenuLangBtn.classList.add('mobile-menu__btn_rotate')
    } else {
      langMenu.style.height = 0
      showMenuLangBtn.classList.remove('mobile-menu__btn_rotate')

    }
  })
}
